import * as types from './types';

const initialState = {
  postings: [],
  numberOfPostings: 0,
  loading: false,
  fetchPostingsError: false,
  isCompleteRecievedResponse: null,
  isComplete: null,
  isCompleteError: null,
  isCompleteLoading: null,
  recievedPostingsResponse: false,
  archivePostError: false,
  archivingPost: false,
  duplicatedCount: 0,
  facets: [],
  nearEndPostingCount: 0,
  socialAdsReport: null,
  dashboardInfo: null,
  loadingDashboardInfo: false,
  dashboardInfoError: false,
  finishReason: [],
  loadingFinishReason: false,
  postingsQualityToExport: [],
  postingsQualityToExportIsLoading: false,
  postingsQualityToExportCompleted: false,
  postingsQualityToExportFailed: false
};

function getPostingsNearEndCount(facets) {
  let count = 0;
  if (facets) {
    // eslint-disable-next-line array-callback-return
    facets.map(facet => {
      if (facet.facetName === 'status') {
        count = facet.values ? facet.values.NEAR_END : 0;
      }
    });
  }
  return count || 0;
}

function postingReducer(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_POSTINGS:
      return action.meta.withoutLoading
        ? state
        : { ...state, loading: true, fetchPostingsError: false, recievedPostingsResponse: false };

    case types.FETCH_POSTINGS_COMPLETED:
      return {
        ...state,
        loading: false,
        recievedPostingsResponse: true,
        // eslint-disable-next-line
        postings:
          // eslint-disable-next-line no-nested-ternary
          action.meta.mergeNewPostings
            ? state.postings.concat(action.payload.postings)
            : action.payload.postings
            ? action.payload.postings
            : [],
        fetchPostingsError: false,
        numberOfPostings: action.payload.numberOfPostings,
        isCompleteRecievedResponse: false,
        facets: action.payload.facets || [],
        nearEndPostingCount: getPostingsNearEndCount(action.payload.facets)
      };

    case types.FETCH_POSTINGS_FAILED:
      return { ...state, loading: false, fetchPostingsError: true };

    case types.RESET_POSTINGS:
      return {
        ...state,
        ...initialState,
        loading: true
      };

    case types.UPDATE_POSTING:
      return {
        ...state,
        postings: [
          ...state.postings.slice(0, action.payload.postingIndex),
          {
            ...state.postings[action.payload.postingIndex],
            stateAndDates: [
              {
                ...state.postings[action.payload.postingIndex].stateAndDates[0],
                ...action.payload
              }
            ],
            publicationPlan: action.payload.publicationPlan
          },
          ...state.postings.slice(action.payload.postingIndex + 1)
        ]
      };

    case types.CHECK_DRAFT_IS_COMPLETE:
      return {
        ...state,
        isCompleteLoading: true
      };

    case types.CHECK_DRAFT_IS_COMPLETE_COMPLETED:
      return {
        ...state,
        isCompleteLoading: false,
        isCompleteError: null,
        isComplete: action.payload,
        isCompleteRecievedResponse: true
      };

    case types.CHECK_DRAFT_IS_COMPLETE_FAILED:
      return {
        ...state,
        isCompleteLoading: false,
        isCompleteError: action.payload,
        isCompleteRecievedResponse: true,
        isComplete: null
      };
    case types.FETCH_VISITS_FAILED:
      return {
        ...state,
        postings: state.postings.map(p => {
          if (p.postingId === action.meta.query.postingId) {
            p.loadingVisits = false;
            p.visitsError = true;
          }
          return p;
        })
      };

    case types.FETCH_VISITS_COMPLETED:
      return {
        ...state,
        postings: state.postings.map(p => {
          if (p.postingId === action.meta.query.postingId) {
            p.visits = action.payload;
            p.loadingVisits = false;
            p.visitsError = false;
          }
          return p;
        })
      };
    case types.FETCH_QUALITY_FAILED:
      return {
        ...state,
        postings: state.postings.map(p => {
          if (p.postingId === action.meta.query.postingId) {
            p.loadingQuality = false;
            p.qualityError = true;
          }
          return p;
        })
      };

    case types.FETCH_QUALITY_COMPLETED:
      return {
        ...state,
        postings: state.postings.map(p => {
          if (p.postingId === action.meta.query.postingId) {
            p.quality = action.payload.percentage_correctness && parseInt(action.payload.percentage_correctness);
            p.qualityStatus = action.payload !== '' ? action.payload.quality_status : null;
            p.validations = action.payload !== '' ? action.payload.validations : null;
            p.loadingQuality = false;
            p.qualityError = action.payload === '';
            p.isDuplicate =
              action.payload.validations && action.payload.validations.some(v => v.rule_id === 'duplicate');
            p.isPenalized =
              action.payload.percentage_correctness &&
              parseInt(action.payload.percentage_correctness) === 0 &&
              action.payload.validations &&
              action.payload.validations.some(v => v.rule_id === 'deployment');
          }
          return p;
        })
      };

    case types.FETCH_VISITS:
      return {
        ...state,
        postings: state.postings.map(p => {
          if (p.postingId === action.meta.query.postingId) {
            p.loadingVisits = true;
          }
          return p;
        })
      };

    case types.FETCH_QUALITY:
      return {
        ...state,
        postings: state.postings.map(p => {
          if (p.postingId === action.meta.query.postingId) {
            p.loadingQuality = true;
          }
          return p;
        })
      };

    case types.FETCH_PERFORMANCE_STATUS:
      return {
        ...state,
        postings: state.postings.map(p => {
          if (p.postingId === action.meta.query.postingId) {
            p.loadingPerformanceStatus = true;
          }
          return p;
        })
      };

    case types.FETCH_PERFORMANCE_STATUS_COMPLETED:
      return {
        ...state,
        postings: state.postings.map(p => {
          if (p.postingId === action.meta.query.postingId) {
            p.performanceStatus = action.payload.status || 'NO-DATA-AVAILABLE';
            p.daysLeftToQuality = action.payload.daysLeftToQuality;
            p.loadingPerformanceStatus = false;
            p.performanceStatusError = false;
          }
          return p;
        })
      };

    case types.FETCH_PERFORMANCE_STATUS_FAILED:
      return {
        ...state,
        postings: state.postings.map(p => {
          if (p.postingId === action.meta.query.postingId) {
            p.loadingPerformanceStatus = false;
            p.performanceStatusError = true;
            p.performanceStatus = 'NO-DATA-AVAILABLE';
            p.daysLeftToQuality = null;
          }
          return p;
        })
      };

    case types.REMOVE_ONE_POST:
      return {
        ...state,
        postings: state.postings.filter(p => p.postingId !== action.postingId),
        numberOfPostings: state.numberOfPostings - 1
      };

    case types.DUPLICATE_POST_COMPLETED:
      return {
        ...state,
        duplicatedCount: action.payload.totalDuplicated
      };
    case types.CHECK_POSTING:
      return {
        ...state,
        postings: state.postings.map(posting => {
          if (!action.postingId && !posting.postingFull) {
            posting.checked = action.checked;
          } else if (posting.postingId === action.postingId) {
            posting.checked = action.checked;
          }
          return posting;
        })
      };
    case types.GET_SOCIAL_ADS_REPORT_COMPLETED:
      return {
        ...state,
        postings: state.postings.map(p => {
          const stringId = p.postingId && p.postingId.toString();
          if (stringId === action.payload.idAviso) {
            p.socialAdsReport = action.payload;
          }
          return p;
        })
      };

    case types.FETCH_REPORTS_ERROR:
      return {
        ...state,
        postings: state.postings.map(p => {
          if (p.postingId === action.meta.postingId) {
            p.loadingReports = false;
            p.reportsError = true;
          }
          return p;
        })
      };

    case types.FETCH_REPORTS:
      return {
        ...state,
        postings: state.postings.map(p => {
          if (p.postingId === action.meta.postingId) {
            p.loadingReports = true;
          }
          return p;
        })
      };

    case types.FETCH_REPORTS_COMPLETED:
      return {
        ...state,
        postings: state.postings.map(p => {
          if (p.postingId === action.meta.postingId) {
            p.loadingReports = false;
            p.postingReports = action.payload;
          }
          return p;
        })
      };

    case types.POSTING_VIEWS_STATS:
      return {
        ...state,
        postings: state.postings.map(p => {
          if (p.postingId === action.meta.query.postingId) {
            p.loadingLeads = true;
          }
          return p;
        })
      };

    case types.POSTING_VIEWS_STATS_FAILED:
      return {
        ...state,
        postings: state.postings.map(p => {
          if (p.postingId === action.meta.query.postingId) {
            p.loadingLeads = false;
            p.leadsError = true;
          }
          return p;
        })
      };

    case types.POSTING_VIEWS_STATS_COMPLETED:
      return {
        ...state,
        postings: state.postings.map(p => {
          if (p.postingId === action.meta.postingId) {
            p.viewsStats = action.payload.views || 0;
            p.impressionsStats = action.payload.impressions || 0;
            p.leads = action.payload.userStats ? action.payload.userStats.total : 0;
            p.loadingLeads = false;
            p.leadsError = false;
          }
          return p;
        })
      };

    case types.GET_POSTING_LOGS:
      return {
        ...state,
        postings: state.postings.map(p => {
          if (p.postingId === action.meta.postingId) {
            p.loadingLogs = true;
            p.logsError = false;
          }
          return p;
        })
      };

    case types.GET_POSTING_LOGS_COMPLETED:
      return {
        ...state,
        postings: state.postings.map(p => {
          if (p.postingId === action.meta.postingId) {
            p.postingLogs = action.payload || null;
            p.loadingLogs = false;
            p.logsError = false;
          }
          return p;
        })
      };

    case types.GET_POSTING_LOGS_FAILED:
      return {
        ...state,
        postings: state.postings.map(p => {
          if (p.postingId === action.meta.postingId) {
            p.loadingLogs = false;
            p.logsError = true;
          }
          return p;
        })
      };
    case types.GET_DASHBOARD_INFO:
      return {
        ...state,
        loadingDashboardInfo: true,
        dashboardInfo: null,
        dashboardInfoError: false
      };
    case types.GET_DASHBOARD_INFO_FAILED:
      return {
        ...state,
        loadingDashboardInfo: false,
        dashboardInfo: null,
        dashboardInfoError: true
      };
    case types.GET_DASHBOARD_INFO_COMPLETED:
      return {
        ...state,
        loadingDashboardInfo: false,
        dashboardInfo: action.payload,
        dashboardInfoError: false
      };

    case types.GET_FINISH_REASON:
      return {
        ...state,
        loadingFinishReason: true
      };

    case types.GET_FINISH_REASON_COMPLETED:
      return {
        ...state,
        finishReason: action.payload || [],
        loadingFinishReason: false
      };

    case types.GET_FINISH_REASON_FAILED:
      return {
        ...state,
        loadingFinishReason: false,
        finishReasonError: true
      };

    case types.GET_FINISH_REASON_BY_POSTING:
      return {
        ...state,
        postings: state.postings.map(p => {
          if (p.postingId === action.meta.query.postingId) {
            p.loadingFinishReasonByPosting = true;
          }
          return p;
        })
      };

    case types.GET_FINISH_REASON_BY_POSTING_COMPLETED:
      return {
        ...state,
        postings: state.postings.map(p => {
          if (p.postingId === action.meta.query.postingId) {
            p.finishReasonByPosting = action.payload;
            p.loadingFinishReasonByPosting = false;
            p.finishReasonErrorByPosting = false;
          }
          return p;
        })
      };

    case types.GET_FINISH_REASON_BY_POSTING_FAILED:
      return {
        ...state,
        postings: state.postings.map(p => {
          if (p.postingId === action.meta.query.postingId) {
            p.loadingFinishReasonByPosting = false;
            p.finishReasonErrorByPosting = true;
            p.finishReasonByPosting = null;
          }
          return p;
        })
      };
    case types.FETCH_POSTINGS_QUALITY_TO_EXPORT:
      return {
        ...state,
        postingsQualityToExportIsLoading: true,
        postingsQualityToExportCompleted: false,
        postingsQualityToExportFailed: false
      };
    case types.FETCH_POSTINGS_QUALITY_TO_EXPORT_COMPLETED:
      return {
        ...state,
        postingsQualityToExport: action.payload,
        postingsQualityToExportIsLoading: false,
        postingsQualityToExportCompleted: true
      };
    case types.FETCH_POSTINGS_QUALITY_TO_EXPORT_FAILED:
      return {
        ...state,
        postingsQualityToExportIsLoading: false,
        postingsQualityToExportCompleted: false,
        postingsQualityToExportFailed: true
      };

    case types.RESET_POSTINGS_QUALITY_TO_EXPORT:
      return {
        ...state,
        postingsQualityToExportIsLoading: false,
        postingsQualityToExportCompleted: false,
        postingsQualityToExportFailed: false
      };

    default:
      return state;
  }
}

export default postingReducer;
